<template>
  <div class="company-list-container">
    <!-- 筛选区域 -->
    <!-- <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="公司名称">
          <el-input
            v-model="filterForm.comp_name"
            placeholder="请输入公司名称"
            clearable
            style="width:200px;"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable style="width:140px;">
            <el-option label="启用" value="启用" />
            <el-option label="禁用" value="禁用" />
            <el-option label="待审核" value="待审核" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card> -->

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never" style="height:70vh; overflow: auto;">
      <el-table
        :data="filteredList"
        v-loading="loading"
        style="width: 100%"
        border
        height="60vh"
        stripe
        row-key="id"
        @row-click="viewCompanyDetail"
        class="company-table"
      >
        <!-- 序号 -->
        <el-table-column type="index" label="序号" width="60" align="center" />

        <!-- 公司ID -->
        <el-table-column prop="id" label="公司ID" width="100" align="center" sortable>
          <template slot-scope="scope">
            <span>{{ scope.row.id || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 公司名称 -->
        <el-table-column prop="comp_name" label="公司名称" min-width="180" sortable>
          <template slot-scope="scope">
            <span class="company-name-text">{{ scope.row.comp_name || scope.row.name || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 公司编码 -->
        <el-table-column prop="comp_code" label="公司编码" width="140" sortable>
          <template slot-scope="scope">
            <span>{{ scope.row.comp_code || scope.row.code || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 联系人 -->
        <el-table-column prop="contact" label="联系人" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.contact || scope.row.contacts || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 联系电话 -->
        <el-table-column prop="phone" label="联系电话" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.phone || scope.row.mobile || scope.row.tel || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 地址 -->
        <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.address || scope.row.addr || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small" effect="dark">
              {{ getDisplayStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 创建时间 -->
        <el-table-column prop="create_time" label="创建时间" width="165" sortable>
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time || scope.row.created_at || scope.row.ctime) }}
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click.stop="viewCompanyDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>

        <!-- 空状态 -->
        <template slot="empty">
          <div class="empty-company">
            <i class="el-icon-document" style="font-size:48px;color:#ddd;"></i>
            <p style="color:#999;margin-top:8px;">暂无公司数据</p>
          </div>
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 公司详情弹窗 -->
    <el-dialog title="公司详情" :visible.sync="dialogVisible" width="60%" top="5vh">
      <el-descriptions :column="2" border v-if="currentCompany">
        <el-descriptions-item label="公司ID">{{ currentCompany.id || '--' }}</el-descriptions-item>
        <el-descriptions-item label="公司编码">
          {{ currentCompany.comp_code || currentCompany.code || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="公司名称">
          <span style="font-weight:600;color:#303133;">
            {{ currentCompany.comp_name || currentCompany.name || '--' }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(currentCompany.status)">
            {{ getDisplayStatus(currentCompany.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="联系人">{{ currentCompany.contact || currentCompany.contacts || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">
          {{ currentCompany.phone || currentCompany.mobile || currentCompany.tel || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="地址" :span="2">
          {{ currentCompany.address || currentCompany.addr || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">
          {{ formatTime(currentCompany.create_time || currentCompany.created_at || currentCompany.ctime) }}
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">
          {{ currentCompany.remark || currentCompany.remarks || '--' }}
        </el-descriptions-item>
      </el-descriptions>

      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xcxrequest from '@/utils/xcxrequest'

export default {
  name: 'CompanyListPC',
  data () {
    return {
      loading: false,
      companyList: [], // 原始数据
      filterForm: {
        comp_name: '',
        status: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 详情弹窗
      dialogVisible: false,
      currentCompany: null
    }
  },

  computed: {
    // 前端过滤（公司名称 + 状态）
    filteredList () {
      let list = this.companyList
      //   const { comp_name, status } = this.filterForm
      if (this.filterForm.comp_name) {
        const keyword = this.filterForm.comp_name.trim().toLowerCase()
        list = list.filter(item => {
          const name = (item.comp_name || item.name || '').toLowerCase()
          return name.includes(keyword)
        })
      }
      if (this.filterForm.status) {
        list = list.filter(item => {
          const st = item.status || ''
          return st === this.filterForm.status
        })
      }
      return list
    }
  },

  mounted () {
    this.loadCompanyList()
  },

  methods: {
    // ---------- 加载公司列表 ----------
    async loadCompanyList () {
      this.loading = true
      try {
        const params = {
          a: 'lists',
          page: this.currentPage,
          page_size: this.pageSize
        }

        // 如果接口支持额外过滤参数，可添加（后端若忽略则无影响）
        // 注意：接口文档未明确支持 keyword/status，此处作为扩展预留
        if (this.filterForm.comp_name) {
          params.keyword = this.filterForm.comp_name.trim()
        }
        if (this.filterForm.status) {
          params.status = this.filterForm.status
        }

        const res = await xcxrequest.post('https://caixiao.lianglianyn.com/ht/comp_lists.php', params)
        console.log('公司列表响应:', res)

        // 兼容 code 为字符串 "0" 或数字 0
        if (res.code === '0' || res.code === 0) {
          this.companyList = res.data || []
          this.total = res.total || this.companyList.length
        } else {
          // 处理未登录等错误
          if (res.code === 1001) {
            this.$message.warning(res.msg || '请先登录')
          } else {
            this.$message.error(res.msg || '获取公司列表失败')
          }
          this.companyList = []
          this.total = 0
        }
      } catch (error) {
        console.error('加载公司列表失败:', error)
        // 网络错误不弹重复提示，避免干扰
        this.companyList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // ---------- 筛选与分页 ----------
    handleSearch () {
      this.currentPage = 1
      this.loadCompanyList()
    },

    handleReset () {
      this.filterForm = { comp_name: '', status: '' }
      this.currentPage = 1
      this.loadCompanyList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadCompanyList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.loadCompanyList()
    },

    // ---------- 工具函数 ----------
    formatTime (timeStr) {
      if (!timeStr) return '--'
      try {
        // 兼容多种时间格式
        const date = new Date(timeStr.replace(/-/g, '/'))
        if (!isNaN(date.getTime())) {
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const day = date.getDate().toString().padStart(2, '0')
          const hours = date.getHours().toString().padStart(2, '0')
          const minutes = date.getMinutes().toString().padStart(2, '0')
          return `${month}-${day} ${hours}:${minutes}`
        }
        return timeStr
      } catch {
        return timeStr
      }
    },

    // ---------- 状态映射 ----------
    getDisplayStatus (status) {
      if (!status) return '待审核'
      const map = {
        启用: '启用',
        禁用: '禁用',
        待审核: '待审核',
        已审核: '已审核',
        已停用: '已停用'
      }
      return map[status] || status
    },

    getStatusType (status) {
      if (!status) return 'warning'
      const map = {
        启用: 'success',
        禁用: 'danger',
        待审核: 'warning',
        已审核: 'primary',
        已停用: 'info'
      }
      return map[status] || 'info'
    },

    // ---------- 查看详情 ----------
    viewCompanyDetail (row) {
      this.currentCompany = row
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.company-list-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .company-table {
      :deep(.el-table__row) {
        cursor: pointer;
        transition: background-color 0.15s;

        &:hover {
          background-color: #f5f7fa !important;
        }
      }

      .company-name-text {
        font-weight: 500;
        color: #303133;
        font-size: 14px;
      }

      .el-button--mini {
        margin: 2px 2px;
      }
    }

    .empty-company {
      text-align: center;
      padding: 40px 0;
      i {
        display: block;
      }
      p {
        margin: 0;
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  // 详情弹窗样式
  :deep(.el-descriptions) {
    .el-descriptions__label {
      width: 110px;
      font-weight: 600;
    }
  }
}
</style>
